import React, { useState } from 'react';
import Star from '../../assets/star.png';
import styled from 'styled-components';
import { BsStarFill } from "react-icons/bs";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

const Div = styled.div`
    .heading{
        font-size: 21px;
        font-weight: 700;
    }

    .color { 
        color: #3545EE;
        font-weight: 500;
    }

    button{
        background: none;
        border: 1px solid black;
        border-radius: 50px;
        height: 35px;
        width: 35px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`
const P = styled.p`
    padding-left: 55px;
    font-size: 35px;
    font-weight: 700;
    
    @media (max-width: 500px){
        text-align: center;
        padding-left: 0px;
    }

    .color{
        color: #3545EE;
    }
`
export const Review = () => {
    const arr = [
        {
            star: 4,
            name: "community",
            para: "I appreciate how Qvani engages with its community. They transparent.",
            country: "Canada"
        },
        {
            star: 3,
            name: "comprehensive",
            para: "I appreciate how Qvani engages with its community. They transparent.",
            country: "USA"
        },
        {
            star: 5,
            name: "innovative",
            para: "I appreciate how Qvani engages with its community. They transparent.",
            country: "India"
        },
        {
            star: 3,
            name: "excellence",
            para: "I appreciate how Qvani engages with its community. They transparent.",
            country: "Vietnam"
        },
        {
            star: 4,
            name: "trust",
            para: "I appreciate how Qvani engages with its community. They transparent.",
            country: "Africa"
        },
        {
            star: 5,
            name: "qvani",
            para: "I appreciate how Qvani engages with its community. They transparent.",
            country: "Amstradam"
        }
    ];

    const getSize = () =>{
        if(window.innerWidth < 500) return 1;
        if(window.innerWidth > 500 && window.innerWidth < 800 ) return 2;
        return 3;
    }
    const size = getSize();
    const [index, setIndex] = useState(0);

    const getData =()=> {
        const result =[];

        for(var i=0; i<size; i++){
            result.push(arr[(i+index)%arr.length]);
        }

        return result;
    }
    
    const next =()=> { setIndex((prev)=> (prev + 1) % arr.length); }
    const prev =()=> { setIndex((prev)=> (prev - 1 + arr.length) % arr.length); }


    return <div className='my-5'>
        <P>Qvani is creating <span className='color'>a better experience</span> <br/> for <span className='color'>every trader</span></P>
        {/* <Div className='row m-0 mt-5 d-flex align-items-center'>
            <div className='col-md-2 text-center'>
                <p className='heading mb-2'>Excellent</p>
                <div className='mb-3'>
                    {
                        new Array(5).fill(null).map(()=> { return <img className='pe-1' src={Star} />; })
                    }
                    
                </div>
                <small> <BsStarFill color='#00B67A' /> Trustpilot</small>
            </div>
            <div className='d-flex align-items-center mt-3 col-md-10'>
                <button className='col-md-1 p-0' onClick={() => prev()}><MdArrowBackIosNew/></button>
                {
                    getData().map((data)=>{
                        return <div className="ps-5 pe-0">
                            { new Array(data.star).fill(null).map((data) => { return <img className='pe-1' src={Star} />; }) }
                            <p className='mb-0 heading'>{data.name}</p>
                            <small>{data.para}</small><br/>
                            <small className='color'>{data.country}</small>
                        </div>
                    })
                }
                <button className='col-md-1 p-0' onClick={() => next()}><MdArrowForwardIos/></button>
            </div>

        </Div> */}
    </div>
}